export const nullToUndefined = <T>(value: T) =>
  value === null ? undefined : value

export default {}
